var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgY(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1499 5.1123H9.5699C17.1202 5.1123 23.2499 10.3514 23.2499 16.8046V26.6981H19.8299C12.2796 26.6981 6.1499 21.4591 6.1499 15.0058V5.1123Z",
    fill: "url(#paint0_linear_16367_8823)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.93 5.1123H43.35V30.5333C43.35 37.3518 37.2203 42.8875 29.67 42.8875H26.25V17.4664C26.25 10.6479 32.3797 5.1123 39.93 5.1123Z",
    fill: "url(#paint1_linear_16367_8823)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16367_8823",
    x1: 9.40679,
    y1: 5.18201,
    x2: 17.8431,
    y2: 28.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33EACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#42CCCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5C9BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6F78C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7A62C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F5BC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16367_8823",
    x1: 42.2661,
    y1: 13.8434,
    x2: 31.8363,
    y2: 31.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BB3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787BD2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgY);
export default __webpack_public_path__ + "static/media/y.420756a6f1e36b03a60ecd50091061a3.svg";
export { ForwardRef as ReactComponent };